/** Sequence generators for Eco (working-memory span). Pure + seeded. */

export const WORD_BANK = [
  'río', 'luna', 'piedra', 'bosque', 'nieve', 'tren', 'lago', 'puente',
  'semilla', 'trueno', 'espejo', 'puerto', 'navaja', 'bandera', 'reloj',
  'diamante', 'camino', 'antorcha', 'isla', 'arena', 'cóndor', 'montaña',
  'ciudad', 'caballo', 'ventana', 'sombrero', 'tambor', 'planeta', 'muralla',
  'abismo', 'cosecha', 'frontera', 'volcán', 'mercado', 'sombra',
]

export const ECO_MODES = [
  { id: 'digits', label: 'Dígitos', hint: 'Repite los números en orden.', emoji: '🔢' },
  { id: 'reverse', label: 'Dígitos inverso', hint: 'Repite los números al revés.', emoji: '🔄' },
  { id: 'visual', label: 'Patrón visual', hint: 'Repite las casillas en orden.', emoji: '🎛️' },
  { id: 'words', label: 'Palabras', hint: 'Recuerda las palabras y su orden.', emoji: '🔤' },
]

export function startLength(mode) {
  if (mode === 'visual') return 3
  if (mode === 'words') return 3
  return 3
}

function shuffled(rng, arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

export function makeSequence(rng, mode, len) {
  if (mode === 'digits' || mode === 'reverse') {
    const out = []
    for (let i = 0; i < len; i++) out.push(Math.floor(rng() * 10))
    return out
  }
  if (mode === 'visual') {
    const cells = shuffled(rng, Array.from({ length: 9 }, (_, i) => i)).slice(0, len)
    return cells
  }
  if (mode === 'words') {
    return shuffled(rng, WORD_BANK).slice(0, len)
  }
  return []
}

/** Options shown during the words input phase: the sequence + distractors. */
export function wordChoices(rng, sequence) {
  const decoys = shuffled(rng, WORD_BANK).filter((w) => !sequence.includes(w)).slice(0, 4)
  return shuffled(rng, [...sequence, ...decoys])
}

export function checkAnswer(mode, sequence, answer) {
  if (mode === 'reverse') {
    const expected = [...sequence].reverse()
    return expected.length === answer.length && expected.every((v, i) => v === answer[i])
  }
  return sequence.length === answer.length && sequence.every((v, i) => v === answer[i])
}
